import { render, staticRenderFns } from "./SideMenuItem.vue?vue&type=template&id=3ae44d8e&scoped=true&"
import script from "./SideMenuItem.vue?vue&type=script&lang=js&"
export * from "./SideMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae44d8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ae44d8e')) {
      api.createRecord('3ae44d8e', component.options)
    } else {
      api.reload('3ae44d8e', component.options)
    }
    module.hot.accept("./SideMenuItem.vue?vue&type=template&id=3ae44d8e&scoped=true&", function () {
      api.rerender('3ae44d8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/SideMenuItem.vue"
export default component.exports